/**
 * /client-engagement/searches/detail — the sidebar's parameter-less landing.
 *
 * The nav item exists because the v38 prototype had a standalone Search Detail
 * screen, and quietly dropping it would change the agreed information
 * architecture. But a detail page needs a subject, so this resolves one:
 *
 *   - a search viewed earlier in this browser → redirect straight to it;
 *   - nothing remembered → a short "pick a search" state pointing at the list.
 *
 * Sub-task 02 left this route on the generic ComingSoon placeholder and flagged
 * the decision as open. This is the answer: keep the item, give it a landing
 * behaviour, and never show a detail page with no search in it.
 */

import { Link, Navigate } from "react-router-dom";

import { readLastViewedSearch } from "./lastViewedSearch";
import { searchDetailPath } from "../../../routing/paths";

export function SearchDetailLanding() {
  const lastViewed = readLastViewedSearch();

  if (lastViewed) {
    // `replace` so the browser Back button returns to wherever they came from
    // rather than bouncing through this redirect again.
    return <Navigate to={searchDetailPath(lastViewed)} replace />;
  }

  return (
    <div data-testid="search-detail-landing" className="flex flex-col gap-4 p-8">
      <h1 className="text-display text-text">Search Detail</h1>
      <p className="max-w-prose text-body text-text-secondary">
        Pick a search to see its performance report — stage distribution, the highest-stage funnel,
        rejection reasons and additions over time.
      </p>
      <Link
        to="/client-engagement/searches"
        className="w-fit rounded-md bg-accent px-4 py-2 text-body text-bg hover:bg-accent-hover"
      >
        Browse My Searches
      </Link>
    </div>
  );
}
